const AttachIFrame = ({
    style = null,
    id,
    zoid,
    sendHostMessage = null,
    data,
}) => {
    const div = document.createElement('div')

    if (style) {
        Object.assign(div.style, style)
    } else {
        // eslint-disable-next-line no-console
        console.warn(`No style defined for ${id}`)
    }

    div.setAttribute('id', id)

    document.body.appendChild(div)

    const zoidPayload = {
        ...data,
    }

    if (sendHostMessage) {
        zoidPayload.sendHostMessage = sendHostMessage
    }

    const zoidInstance = zoid(zoidPayload)

    zoidInstance.render(`#${id}`)

    return zoidInstance
}

export default AttachIFrame
